import React from 'react';
import { Outlet } from 'react-router-dom';

const ConsultasPage: React.FC = () => {
  return <Outlet />;
};

export default ConsultasPage;